import styled from 'styled-components'

export const FooterRoot = styled.footer`
    background-color: var(--surface-0);
    color: #ffffff;
`

export const FooterMain = styled.div`
    max-width: var(--container);
    margin: 0 auto;
    padding: 48px 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;

    @media (max-width: 1100px) {
        padding: 40px 6%;
        gap: 24px;
    }

    @media (max-width: 900px) {
        padding: 36px 5%;
        gap: 22px;
    }
`

export const FooterLogos = styled.div`
    display: grid;
    grid-template-columns: 4fr 2.67fr 2.67fr 2.67fr;
    align-items: center;
    column-gap: 50px;
    width: 100%;

    @media (max-width: 1100px) {
        column-gap: 36px;
    }

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 28px;
        row-gap: 32px;
    }

    @media (max-width: 520px) {
        grid-template-columns: minmax(0, 1fr);
        row-gap: 28px;
    }
`

export const FooterLogoCell = styled.div`
    min-width: 0;

    img {
        display: block;
        width: 100%;
        max-width: 200px;
        height: auto;
        object-fit: contain;
    }

    &.brand-cell img {
        max-width: 300px;
    }

    @media (max-width: 900px) {
        display: flex;
        justify-content: center;

        img {
            max-width: 300px;
        }

        &.brand-cell {
            grid-column: 1 / -1;
        }
    }
`

export const FooterBrandContent = styled.div`
    display: flex;
    width: min(100%, 300px);
    flex-direction: column;
    align-items: center;
    gap: 16px;
`

export const FooterEnrollLink = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    padding: 15px 22px;
    border: 0;
    border-radius: var(--radius-pill);
    background: var(--brand);
    color: var(--ink-inverse);
    box-shadow: none;
    font-family: var(--font-heading);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-decoration: none;
    transition: opacity var(--duration-ui) var(--ease-out);

    &:hover {
        opacity: 0.87;
        color: var(--ink-inverse);
    }
`

export const FooterCities = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 20px;
    color: #ffffff;
    font-family: var(--font-body);
    font-size: 16px;
    line-height: 1.4;
    letter-spacing: 0.02em;

    .city {
        white-space: nowrap;
    }

    .separator {
        color: rgba(255, 255, 255, 0.35);
        user-select: none;
    }

    @media (max-width: 900px) {
        font-size: 15px;
        gap: 6px 16px;
    }
`

export const CopyrightBar = styled.div`
    background-color: var(--surface-0);
    color: #777777;
    padding: 22px 8%;
    text-align: center;

    .inner {
        max-width: var(--container);
        margin: 0 auto;
    }

    p {
        margin: 0;
        font-family: var(--font-body);
        font-size: 14px;
        line-height: 1.5;
    }
`
